export enum possibleUserDataStatus {
    idle = 'idle',
    loading = 'loading',
    succeeded = 'succeeded',
    failed = 'failed',
}

export type UserDataType = {
    joinedLeagues: string[];
}